// extracted by mini-css-extract-plugin
module.exports = {"btn":"FaqPageStyle_btn__2_HYO","icon":"FaqPageStyle_icon__kUR8D","img":"FaqPageStyle_img__3oZSz","icon_container":"FaqPageStyle_icon_container__FaLfK"};